// The current application coordinates were pre-registered in a B2C tenant.
export const apiConfig = {
  b2cScopes: ["https://3dlibrary.onmicrosoft.com/b25a57f3-2d4d-44b9-9ce1-f9c87adfbc56/demo.read"],
  api: process.env.NODE_ENV === 'production' ? "https://jml3d.azurewebsites.net" : process.env.REACT_APP_BACKEND,
};
